import Settings from '../resources/settings';

const baseUrl = Settings.API_BASE_PATH;

export const getBatchPrintRecoveryGoalSettingURI = () => `${baseUrl}/recoverygoal-setting`;
